import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { CoreModule } from "./core/core.module";
import { AppComponent } from './app.component';
import { GestaoModule } from "./pages/gestao/gestao.module";
import { AppRoutingModule } from "./app-routing.module";
import { VisitantesModule } from "./pages/visitante/visitantes.module";
import { HomeComponent } from "./pages/home/home.component";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";
import { ProjetoModule } from "./projeto/projeto.module";
import { NotTenantPageComponent } from "./pages/not-tenant-page/not-tenant-page.component";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        ErrorPageComponent,
        NotTenantPageComponent
    ],
    imports: [
        BrowserModule,
        CoreModule,
        ProjetoModule,
        GestaoModule,
        VisitantesModule,
        AppRoutingModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {

    // constructor(
    //     private _dataService: DataService,
    //     private http: Http
    // ) {
        // const serverUrl = this._dataService.getServer();
        //
        // var extractData = (function(response: any) {
        //     let data: string[] = response.json();
        //     this._dataService.setTenants(data);
        // }.bind(this));
        //
        // var handleError = (function(response: any) {
        //     //alert("Não foi possível buscar as os tenants");
        //     console.log(response);
        // });
        //
        // this.http.get(serverUrl + '/projetos/listar-todos')
        //     .toPromise()
        //     .then(extractData)
        //     .catch(handleError);
    // }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/